import createCachedSelector from 're-reselect';

const getNature = (state, { data: { nature } }) => nature;
const getQualities = ({ myself: { qualities } }) => qualities;
const cacheKey = getNature;

const inputs = [getNature, getQualities];
const output = (nature, qualities) => qualities.filter(q => q.nature === nature);

export default createCachedSelector(inputs, output)(cacheKey);